import React, { createContext, useCallback, useState } from 'react';
import { IDisbursementRollupProps } from '../IDisbursementRollupProps';
import type { FCWithChildren } from '../../../../../types/FCWithChildren';

export type IDisbursementRollupDispatch = (id: string, x?: IDisbursementRollupProps) => void;
export const DisbursementRollupContext = createContext<{ [key: string]: IDisbursementRollupProps | undefined }>({});
export const DisbursementRollupDispatchContext = createContext<IDisbursementRollupDispatch>(() => {});

export const DisbursementRollupProvider: FCWithChildren = ({ children }) => {
  const [state, setState] = useState<{ [key: string]: IDisbursementRollupProps | undefined }>({});

  const dispatch = useCallback(
    (id: string, value?: IDisbursementRollupProps) => {
      setState((old) => ({ ...old, [id]: value }));
    },
    [setState]
  );

  return (
    <DisbursementRollupDispatchContext.Provider value={dispatch}>
      <DisbursementRollupContext.Provider value={state}>{children}</DisbursementRollupContext.Provider>
    </DisbursementRollupDispatchContext.Provider>
  );
};
